export default "__VITE_ASSET__CEHU0x1l__"